import "./style.scss";
import { FC } from "react";
import backForDocMalta from "@/src/assets/admissionOfficePage/back-for-doc-malta.webp";
import backForDocPoland from "@/src/assets/admissionOfficePage/back-for-doc-poland.webp";
import backForDocUkraine from "@/src/assets/admissionOfficePage/back-for-doc-ukraine.webp";
import { AOPMaltaAdmissionData } from "@/src/types/admissionOffice";
import type { AdmissionOfficeCountry } from "../../../admissionOfficeCountry";

const BACKGROUNDS: Record<AdmissionOfficeCountry, string> = {
  malta: backForDocMalta,
  poland: backForDocPoland,
  ukraine: backForDocUkraine,
};

interface AOPPrevProps {
  country: AdmissionOfficeCountry;
  bodyForPrev: AOPMaltaAdmissionData;
  showInvoiceInPreview: boolean;
}

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev, showInvoiceInPreview }) => {
  const actualBg = BACKGROUNDS[country];
  const polandLikeLayout = country === "poland" || country === "ukraine";
  const dateLine = bodyForPrev.currentDate ? bodyForPrev.currentDate : "-";

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${country} admission`}>
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        <div className="admission-office-prev-section title">
          {polandLikeLayout ? <p>ADMISSION/CONFIRMATION LETTER</p> : "ADMISSION/CONFIRMATION LETTER"}
        </div>
        <div className="admission-office-prev-section number-and-date">
          {polandLikeLayout ? (
            <>
              <span>Date: {dateLine}</span>
              <span>№ -</span>
            </>
          ) : (
            <>
              <span>№ -</span>
              <span>Date: {dateLine}</span>
            </>
          )}
        </div>
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
          <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
          <p>Course: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
          <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
        </div>
        <div className="admission-office-prev-section signature">
          <p>Head of Foreign Students department</p>
          <p>Fedorova Anzhelika</p>
          <p>International European University</p>
        </div>
        {bodyForPrev ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.body?.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
      {showInvoiceInPreview ? (
        <div className={`admission-office-prev ${country} admission`}>
          <img className="admission-office-prev-background" src={actualBg} alt="" />
          <div className="admission-office-prev-section title">{polandLikeLayout ? <p>INVOICE</p> : "INVOICE"}</div>
          <div className="admission-office-prev-section number-and-date">
            {polandLikeLayout ? (
              <>
                <span>Date: {dateLine}</span>
                <span>№ - </span>
              </>
            ) : (
              <>
                <span>№ - </span>
                <span>Date: {dateLine}</span>
              </>
            )}
          </div>
          <div className="admission-office-prev-section info">
            <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
            <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
            <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
            <p>Course: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
            <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
            <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
          </div>
          <div className="admission-office-prev-section signature">
            <p>Head of Foreign Students department</p>
            <p>Fedorova Anzhelika</p>
            <p>International European University</p>
          </div>
          <div className="admission-office-prev-section body-content">
            {(bodyForPrev.invoiceBody ?? []).map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AOPPrev;
